// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  //local
  // apiURL: 'http://localhost:8080/api',

  //staging
  // apiURL: 'https://sabswebbe.ergrouptech.com/api',

  //Temporary Live API
  // apiURL: 'https://websiteapi.sabs.org.my/api',

  // Live API
  apiURL:'https://websiteapi.sabs.org.my/api',
  firebaseConfig: {
    apiKey: "AIzaSyCffT7MsG6cxjbpQqvEn9QV2xtT0X4NxcI",
    authDomain: "sabs-website-fe.firebaseapp.com",
    projectId: "sabs-website-fe",
    storageBucket: "sabs-website-fe.appspot.com",
    messagingSenderId: "589895983062",
    appId: "1:589895983062:web:ec53e86db26c3bdf280e77"
  }
};
